module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.7a2cf1b2.jpeg";